/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-space.vue?vue&type=template&id=5f8643aa&scoped=true"
import script from "./pc-space.vue?vue&type=script&lang=js"
export * from "./pc-space.vue?vue&type=script&lang=js"
import style0 from "./pc-space.vue?vue&type=style&index=0&id=5f8643aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8643aa",
  null
  
)

export default component.exports